/**
 * Asynchronously loads the component
 */

import { lazyLoad } from '../../../utils/loadable';

export const AccommodationsPage = lazyLoad(
    () => import('./index'),
    (module) => module.AccommodationsPage,
);
